import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const OPEN_PALETTE = 'ui/OPEN_PALETTE';
const WHITE_NAV = 'ui/WHITE_NAV';
const TOP_NAV = 'ui/TOP_NAV';
const SHOW_MENU = 'ui/SHOW_MENU';
const HIDE_MENU = 'ui/HIDE_MENU';
const SHOW_UP = 'ui/SHOW_UP';
const HIDE_UP = 'ui/HIDE_UP';
const ANOTHER_BRANDS = 'ui/ANOTHER_BRANDS';
const HIDE_ANOTHER = 'ui/HIDE_ANOTHER';
const SET_GALLERY = 'ui/SET_GALLERY';
const SET_GALLERY_INDEX = 'ui/SET_GALLERY_INDEX';
const ON_BACKLIST = 'ui/ON_BACKLIST';
const OFF_BACKLIST = 'ui/OFF_BACKLIST';
const SHOW_PALETTE = 'ui/SHOW_PALETTE';
const HIDDEN_PALETTE = 'ui/HIDDEN_PALETTE';

export const openPalette = createAction(OPEN_PALETTE);
export const whiteNav = createAction(WHITE_NAV);
export const topNav = createAction(TOP_NAV);
export const showMenu = createAction(SHOW_MENU);
export const hideMenu = createAction(HIDE_MENU);
export const showUp = createAction(SHOW_UP);
export const hideUp = createAction(HIDE_UP);
export const showAnother = createAction(ANOTHER_BRANDS);
export const hideAnother = createAction(HIDE_ANOTHER);
export const setGallery = createAction(SET_GALLERY);
export const setGalleryIndex = createAction(SET_GALLERY_INDEX);
export const onBacklist = createAction(ON_BACKLIST);
export const offBacklist = createAction(OFF_BACKLIST);
export const showPalette = createAction(SHOW_PALETTE);
export const hiddenPalette = createAction(HIDDEN_PALETTE);

export const colorSet = [
  // '#ffffff', // white
  '#959595', // gray
  '#ffdf45', // yellow
  '#a7ea5f', // green
  '#6da1fa', // blue
  '#988ff1', // purple
  '#ffa0ab', // pink
  '#ef4b30' // red
];

const randomColorIndex = () => {
  return Math.floor(Math.random() * colorSet.length);
};

const initialState = Map({
  color: colorSet[5],
  colorIndex: 2,
  isWhiteNav: false,
  showMenu: false,
  appearUp: false,
  showAnotherBrands: false,
  setGallery: 0,
  galleryIndex: 0,
  toggleBacklist: false,
  isShowPalette: true
});

export default handleActions(
  {
    [OPEN_PALETTE]: state => {
      let currentIndex = state.get('colorIndex');
      let flag = true;

      while (flag) {
        flag = false;
        let tempIndex = randomColorIndex();

        if (currentIndex === tempIndex) {
          flag = true;
        } else {
          return state
            .set('colorIndex', tempIndex)
            .set('color', colorSet[tempIndex]);
        }
      }
    },
    [WHITE_NAV]: state => state.set('isWhiteNav', true),
    [TOP_NAV]: state => state.set('isWhiteNav', false),
    [SHOW_MENU]: state => state.set('showMenu', true),
    [HIDE_MENU]: state => state.set('showMenu', false),
    [SHOW_UP]: state => state.set('appearUp', true),
    [HIDE_UP]: state => state.set('appearUp', false),
    [ANOTHER_BRANDS]: state =>
      state.set('showAnotherBrands', !state.get('showAnotherBrands')),
    [HIDE_ANOTHER]: state => state.set('showAnotherBrands', false),
    [SET_GALLERY]: (state, action) => {
      const { index } = action.payload;
      return state.set('setGallery', index);
    },
    [SET_GALLERY_INDEX]: (state, action) => {
      const { index } = action.payload;
      return state.set('galleryIndex', index);
    },
    [ON_BACKLIST]: state => state.set('toggleBacklist', true),
    [OFF_BACKLIST]: state => state.set('toggleBacklist', false),
    [SHOW_PALETTE]: state => state.set('isShowPalette', true),
    [HIDDEN_PALETTE]: state => state.set('isShowPalette', false)
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/modules/ui.js